module.exports = __webpack_public_path__ + "media/images/about-landing-a5d149c4.jpeg";